// components/HeroSection.jsx
import React from 'react';
import logowhite from '../assets/logo/logo-white.png'
import { Link } from 'react-router-dom';

export default function HeroSection() {
    return (
        <section className="relative bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white py-24 md:py-32 overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-40"></div>
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <div className="text-center">
                    {/* LOGO POSITIONED HERE */}
                    <div className="flex justify-center mb-8">
                        <div className="p-4 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl">
                            <img
                                src={logowhite}
                                onContextMenu={(e) => e.preventDefault()}
                                draggable="false"
                                alt="Arxis Logo"
                                className="h-16 w-auto object-contain"
                            />
                        </div>
                    </div>

                    <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6">
                        Precision Accounting That <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-300 to-white">Powers Your Business</span> Forward
                    </h1>
                    <p className="text-xl md:text-2xl max-w-4xl mx-auto mb-10 text-indigo-100">
                        Arxis Accounting is the all-in-one financial command center built for sole proprietors and growing Nigerian businesses.
                        Handle sales, invoicing, VAT compliance, payroll, and payments — all in one secure, intuitive platform.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <Link to="/start">
                            <button className="px-8 py-4 bg-white text-blue-900 font-semibold text-lg rounded-lg hover:bg-gray-100 transition shadow-lg">
                                Start Free 14-Day Trial
                            </button>
                        </Link>
                        {/* <button className="px-8 py-4 border-2 border-white font-semibold text-lg rounded-lg hover:bg-white hover:text-blue-900 transition">
                            Watch Demo
                        </button> */}
                    </div>
                </div>
            </div>
        </section>
    );
}